import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const OpcuaDatapointMapping = React.lazy(async () => ({
    default: (await import('@oc/opcua-datapoint-mapping/module')).OpcuaDatapointMappingModule
}))

export function OpcuaDatapointMappingComponent() {
    return <SuspenseWhileLoading LazyComponent={OpcuaDatapointMapping} />
}
